import { FeatureTogglePort } from '../../../ports'
import { toggle } from '@otto-ec/global-resources/toggle'

export const featureTogglesAssetsAdapter: FeatureTogglePort = (
  feature: string,
  defaultValue: boolean
) => toggle.get(feature, defaultValue)
